/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_codon_col_per1000 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/1000`)
};

const es_codon_col_per1000 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/1000`)
};

const de_codon_col_per1000 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/1000`)
};

const nl_codon_col_per1000 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/1000`)
};

const fr_codon_col_per1000 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/1000`)
};

const it_codon_col_per1000 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/1000`)
};

const pt_br2_codon_col_per1000 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/1000`)
};

const pt_codon_col_per1000 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/1000`)
};

const ja_codon_col_per1000 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/1000`)
};

const zh_codon_col_per1000 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每千个`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const codon_col_per1000 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.codon_col_per1000(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("codon_col_per1000", locale)
	if (locale === "en") return en_codon_col_per1000(inputs)
	if (locale === "es") return es_codon_col_per1000(inputs)
	if (locale === "de") return de_codon_col_per1000(inputs)
	if (locale === "nl") return nl_codon_col_per1000(inputs)
	if (locale === "fr") return fr_codon_col_per1000(inputs)
	if (locale === "it") return it_codon_col_per1000(inputs)
	if (locale === "pt-BR") return pt_br2_codon_col_per1000(inputs)
	if (locale === "pt") return pt_codon_col_per1000(inputs)
	if (locale === "ja") return ja_codon_col_per1000(inputs)
	return zh_codon_col_per1000(inputs)
};